export const saveAssigns = () => {
    let pack__save_button = $('#ExpensePackApp button.pack__save_button');
    setTimeout(function () {
        pack__save_button.html('<i class="fas fa-spinner fa-spin"></i> Save assigns');
        pack__save_button.click();
        pack__save_button.prop('disabled', true);
        setTimeout(function () {
            pack__save_button.html('Save assigns');
            pack__save_button.prop('disabled', false);
        }, 1000);
    }, 500);
};
